import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Bisrat  Yalew',
    title: "FullStack Developer",
    desciption:' "The best way to predict the future is to invent it.    The two most important days in your life are the day you are born and the day you find out why." ',
    image: 'https://avatars.githubusercontent.com/u/30002154?v=4',
    resumePdf: resume
}
